"use client"

import { type CheckoutPageSettingsContent } from "@/types"
import { clsx } from "@/src/utils/clsx"

export default function CustomerService({
    customerService,
    className
}: {
    customerService: CheckoutPageSettingsContent["customerService"]
    className?: string
}) {
    const { title, chatButtonText, emailLabel, emailAddress, tel } = customerService
    return (
        <div
            className={clsx(
                "mt-auto flex flex-col gap-4 overflow-x-auto px-12 pb-20 pt-56 sm:px-16 md:px-24 md:pb-24 md:pt-48",
                className
            )}
        >
            <p className="Trade_Gothic_Text_14_150_0_700">{title}</p>

            {chatButtonText && (
                <button
                    type="button"
                    aria-label={chatButtonText}
                    className="w-fit Trade_Gothic_Text_14_150_0_300"
                    onClick={() => {
                        const pocGladly = window.poc?.gladly
                        if (pocGladly) {
                            const firstGladlyInstance = Object.values(pocGladly)[0] as any
                            firstGladlyInstance?.show?.()
                        }
                    }}
                >
                    <span>{chatButtonText}</span>
                </button>
            )}

            {emailAddress && (
                <a
                    href={`mailto:${emailAddress}`}
                    rel="noopener noreferrer"
                    className="w-fit underline Trade_Gothic_Text_14_150_0_300"
                >
                    {emailLabel} {emailAddress}
                </a>
            )}

            {tel && (
                <a
                    href={`tel:${tel}`}
                    className="w-fit underline Trade_Gothic_Text_14_150_0_300"
                >
                    {tel}
                </a>
            )}
        </div>
    )
}
